import { GlobalState } from '@/models/auction-house/state';
import { createSelector } from '@ngrx/store';

export interface DataState {
  activeAuction: {
    punkId: string;
    owner: string | null;
    startBlock: number;
    settled: boolean;
    bid: ActiveBid | null;
    events: BidEvent[];
    
    secondsLeft: number;
    endTime: number;
    blocksRemaining: number;
  }
  currentBlock: number;
};

export interface BidEvent {
  tokenId: number
  type: string
  value: string
  blockNumber: number,
  transactionHash: string,
  fromAccount: {
    id: string
  }
}

export interface ActiveBid {
  id: string;
  value: string;
  transactionHash: string;
  blockNumber: number;
  fromAccount: {
    id: string;
  }
}

export const selectDataState = (state: GlobalState) => state.dataState;

export const selectActiveAuction = createSelector(
  selectDataState,
  (dataState: DataState) => dataState.activeAuction
);

export const selectCurrentBlock = createSelector(
  selectDataState,
  (dataState: DataState) => dataState.currentBlock
);
